import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './locales/zh.json';
import en from './locales/en.json';

export type LocaleType = 'en' | 'zh';

const getDefaultLocale = (): LocaleType => {
  if (window.location.href.includes('.areteup.com') || window.location.href.includes('lang=en')) {
      return 'en';
  }
  return 'zh';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    lng: getDefaultLocale(),
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false,
    },
    // keySeparator: false, // 如果你用扁平key可以不加
  });

export default i18n;